import { api } from '../../../api/common/instances';

const state = {
  groups: [],
};

const getters = {};

const mutations = {
  setGroups(state, groups) {
    state.groups = groups;
  },
};

const actions = {
  async fetchGroups({ commit }) {
    const { data } = await api.get('/groups');
    commit('setGroups', data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
